import drawerAction from "./drawerAction"
import userAction from "./userAction"
import authAction from "./authAction"
import loaderAction from "./loaderAction"
import toastAction from "./toastAction"

const allActions = [
  drawerAction,
  userAction,
  authAction,
  loaderAction,
  toastAction,
]

export default allActions
